import pixel from '../pixel/pixel';
import tools from '../tools/tools';
import { sendBeacon } from './navigator';
import { isWebWorker, hasSendBeacon, hasFetch } from './env';

export const publisherTypes = {
  image: 'image',
  beacon: 'beacon',
  fetch: 'fetch',
  xhr: 'xhr',
};

export function getPublisherByType(type) {
  let publisher;

  switch (type) {
    case publisherTypes.beacon: {
      publisher = beaconPublisher;
      break;
    }
    case publisherTypes.fetch: {
      publisher = fetchPublisher;
      break;
    }
    case publisherTypes.image: {
      publisher = imagePublisher;
      break;
    }
    case publisherTypes.xhr: {
      publisher = xhrPublisher;
      break;
    }
    default: {
      if (isWebWorker()) {
        if (hasFetch()) {
          publisher = fetchPublisher;
        } else {
          publisher = xhrPublisher;
        }
      } else if (hasSendBeacon()) {
        publisher = beaconPublisher;
      } else {
        publisher = imagePublisher;
      }
    }
  }

  return publisher;
}

const getUrl = (baseUrl, data) => baseUrl + '?' + tools.mapToQuery(data);

export function imagePublisher(baseUrl, data) {
  return pixel.fetch(getUrl(baseUrl, data));
}

export function beaconPublisher(baseUrl, data) {
  sendBeacon(getUrl(baseUrl, data));
}

export function fetchPublisher(baseUrl, data) {
  fetch(getUrl(baseUrl, data), {
    credentials: 'include',
  });
}

export function xhrPublisher(baseUrl, data) {
  const xhttp = new XMLHttpRequest();
  xhttp.open('GET', getUrl(baseUrl, data));
  xhttp.withCredentials = true;
  xhttp.send();
}
